import React from "react";
import MainLayout from "../../../components/MainLayout";
import YoutubePlayer from "react-player/youtube";

const Tutoriales = () => {
  const demos = {
    "video1": "https://www.youtube.com/watch?v=XOozXzpkp0A&ab_channel=aaapversc",
    "video2": "https://youtu.be/v5QKS7Hmonc",
    "video3": "https://youtu.be/VoNoGeAFhV4",  
    "video4": "https://youtu.be/ZMl8ac4myFU",
    "video5": "https://www.youtube.com/watch?v=wVITUCGG48E&ab_channel=aaapversc",
    "video6": "https://youtu.be/wruBF22PSWY",
    "video7": "https://youtu.be/wVITUCGG48E",
    "video8": "https://youtu.be/gM7MM2ApAx4",
    "video9": "https://youtu.be/zmgDksEqOx4",
    "video10": "https://youtu.be/ESWPzXUJaxA",
    "video11": "https://www.youtube.com/watch?v=9XSGipqjk4k&ab_channel=aaapversc",
  };

  return (
    <MainLayout>
      <div className="row title_layout">
        <div className="col-6">
          <h5>TUTORIALES</h5>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Ingreso a la plataforma</h6>
            <YoutubePlayer url={demos["video1"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Creación de solicitud</h6>
            <YoutubePlayer url={demos["video2"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Agregar contenedores</h6>
            <YoutubePlayer url={demos["video3"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Agregar BL's</h6>
            <YoutubePlayer url={demos["video4"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Generar QR</h6>
            <YoutubePlayer url={demos["video5"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Ingresar una solicitud</h6>
            <YoutubePlayer url={demos["video6"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Obtener QR</h6>
            <YoutubePlayer url={demos["video7"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Ingresar EIR</h6>
            <YoutubePlayer url={demos["video8"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Corte de demoras</h6>
            <YoutubePlayer url={demos["video9"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Confirmación de naviera</h6>
            <YoutubePlayer url={demos["video10"]} controls />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="tutorialsList">
            <h6>Creación de Usuarios</h6>
            <YoutubePlayer url={demos["video11"]} controls />
          </div>
        </div>
   
     
      </div>
    </MainLayout>
  );
};

export default Tutoriales;
